/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceItem } from './InvoiceItem';
import {
    InvoiceItemFromJSON,
    InvoiceItemFromJSONTyped,
    InvoiceItemToJSON,
    InvoiceItemToJSONTyped,
} from './InvoiceItem';

/**
 * 
 * @export
 * @interface ReportYear
 */
export interface ReportYear {
    /**
     * 
     * @type {number}
     * @memberof ReportYear
     */
    year: number;
    /**
     * 
     * @type {Array<InvoiceItem>}
     * @memberof ReportYear
     */
    items: Array<InvoiceItem>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportYear
     */
    ibrApproved: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportYear
     */
    ibrDraft: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportYear
     */
    hyperonApproved: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportYear
     */
    hyperonDraft: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportYear
     */
    totalApproved: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportYear
     */
    totalDraft: Array<number>;
}

/**
 * Check if a given object implements the ReportYear interface.
 */
export function instanceOfReportYear(value: object): value is ReportYear {
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('ibrApproved' in value) || value['ibrApproved'] === undefined) return false;
    if (!('ibrDraft' in value) || value['ibrDraft'] === undefined) return false;
    if (!('hyperonApproved' in value) || value['hyperonApproved'] === undefined) return false;
    if (!('hyperonDraft' in value) || value['hyperonDraft'] === undefined) return false;
    if (!('totalApproved' in value) || value['totalApproved'] === undefined) return false;
    if (!('totalDraft' in value) || value['totalDraft'] === undefined) return false;
    return true;
}

export function ReportYearFromJSON(json: any): ReportYear {
    return ReportYearFromJSONTyped(json, false);
}

export function ReportYearFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportYear {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'],
        'items': ((json['items'] as Array<any>).map(InvoiceItemFromJSON)),
        'ibrApproved': json['ibr_approved'],
        'ibrDraft': json['ibr_draft'],
        'hyperonApproved': json['hyperon_approved'],
        'hyperonDraft': json['hyperon_draft'],
        'totalApproved': json['total_approved'],
        'totalDraft': json['total_draft'],
    };
}

export function ReportYearToJSON(json: any): ReportYear {
    return ReportYearToJSONTyped(json, false);
}

export function ReportYearToJSONTyped(value?: ReportYear | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': value['year'],
        'items': ((value['items'] as Array<any>).map(InvoiceItemToJSON)),
        'ibr_approved': value['ibrApproved'],
        'ibr_draft': value['ibrDraft'],
        'hyperon_approved': value['hyperonApproved'],
        'hyperon_draft': value['hyperonDraft'],
        'total_approved': value['totalApproved'],
        'total_draft': value['totalDraft'],
    };
}

